import { render } from "./UnlockCrates.vue?vue&type=template&id=64d5f211"
import script from "./UnlockCrates.vue?vue&type=script&lang=js"
export * from "./UnlockCrates.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__